import * as React from "react";

export const UserChatIcon = () => (
    <svg
      width={90}
      height={90}
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="chat bubble icon"
    >
      <path
        d="M32.19 19.431c3.602-.263 7.454-.44 11.404-.523"
        stroke="#000"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.766 27.13c8.928-.309 17.376-.154 26.15-.309M32.766 35.288c8.313-.307 15.394.154 23.707-.307"
        stroke="#000"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.984 56.987c7.586 1.536 9.729 5.838 10.563 10.838 1.39 10.008-10.283 16.958-18.622 11.956-10.287-5.836-7.23-20.848 4.17-22.794 1.11-.28 2.5-.28 3.89 0zM20.733 28.224v14.318c0 2.77 2.31 5.078 5.08 5.078h8.93c1.23 0 1.54.155 2 1.233.874 6.81.18 11.081.488 11.236.616.461 3.65-2.774 6.158-5.965 2.117-2.693 4.284-6.35 4.284-6.35l28.284-.154c2.617 0 4.774-1.692 4.927-4.307.308-2.619.461-6.007.461-8.314 0-6.311-.46-16.012-.77-21.091-.152-2.617-2.153-4.618-4.772-4.774-7.083-.46-20.434-.46-32.748-.46-4.004 0-11.547.305-15.55.46-2.31.153-4.773.154-6.005 2.155-.77 1.234-.77 2.617-.924 3.848.002 3.388.157 10.007.157 13.087z"
        stroke="#000"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.814 63.945c2.026.426 3.733 2.24 4.052 4.159.533 3.837-3.945 6.504-7.144 4.585-3.946-2.238-2.773-7.997 1.6-8.744.427-.106.961-.106 1.492 0z"
        stroke="#000"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.15 73.222c-2.453 1.172-3.731 2.666-4.371 5.758m7.996-5.545c.959.32 1.707.96 2.345 1.6.64.746 1.494 2.557 1.706 4.264l-4.051-5.864z"
        stroke="#000"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M64.44 21.337c1.489-1.822 7.782-3.146 8.278 1.821.498 4.968-4.967 4.472-5.131 5.963-.166 1.489 0 3.642 0 3.642M68.48 37.19c-.577-2.502-1.925.576-.577.576"
        stroke="#000"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.793 73.453c1.23 1.934 4.793 1.406 5.976 1.406"
        stroke="#000"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </svg>
  );
